import Api from '@/providers/Api'
import Validation from '@/providers/Validation'
import { email, required } from 'vuelidate/lib/validators'
import Vue from 'vue'

async function required_if_found (value) {        //  do NOT convert to (value)=> format
    let not_found = this.$v.form.not_found?.$model
    if (!not_found) {
        return !!value
    }
    return true
}

async function required_if_not_found (value) {        //  do NOT convert to (value)=> format
    let not_found = this.$v.form.not_found?.$model
    if (not_found) {
        return !!value
    }
    return true
}

export default {
    fields: {
        rental_company: {
            dbFieldName: 'rental_company',
            label: 'Rental Company',
            type: 'multiselect',
            multiselectOptions: {
                placeholder: 'Search by name & address',
                label: 'nameAndAddress',
                multiple: false,
            },
            async doSearch (query) {
                const filters = {
                    nameAndAddress: { field: 'nameAndAddress', type: 'hidden', value: query },
                    status: { field: 'status', type: 'hidden', value: 'APPROVED' }
                }
                return Api.getItems(this, 'rental-company', filters)
            },
            showIf (model) {
                const isShown = !model.not_found
                if (!isShown) {
                    model.rental_company = null
                }
                return isShown
            },
            validations: { required_if_found },
        },
        not_found: {
            label: 'Rental company not found in list',
            type: 'check',
        },
        agreement_number: {
            label: 'Rental Agreement Number',
            type: 'text',
            showIf (model) {
                const isShown = model.not_found
                if (!isShown) {
                    model.agreement_number = null
                }
                return isShown
            },
            validations: { required_if_not_found },
        },
        //NB: Duplicate any changes below in RentalCompany.js, sans showIf()
        //These are submitted to rental company model but via the rental controller
        name: {
            label: 'Rental Company Name',
            type: 'text',
            showIf (model) {
                const isShown = model.not_found
                if (!isShown) {
                    model.name = null
                }
                return isShown
            },
            validations: { required_if_not_found },
        },
        address_1: {
            label: 'Address 1',
            type: 'text',
            showIf (model) {
                const isShown = model.not_found
                if (!isShown) {
                    model.address_1 = null
                }
                return isShown
            },
            validations: { required_if_not_found },
        },
        address_2: {
            label: 'Address 2',
            type: 'text',
            showIf (model) {
                const isShown = model.not_found
                if (!isShown) {
                    model.address_2 = null
                }
                return isShown
            },
        },
        city: {
            label: 'City',
            type: 'text',
            showIf (model) {
                const isShown = model.not_found
                if (!isShown) {
                    model.city = null
                }
                return isShown
            },
            validations: { required_if_not_found },
        },
        state: {
            label: 'State',
            type: 'state',
            showIf (model) {
                const isShown = model.not_found
                if (!isShown) {
                    model.state = null
                }
                return isShown
            },
            validations: { required_if_not_found },
        },
        zip: {
            label: 'Zip',
            type: 'text',
            showIf (model) {
                const isShown = model.not_found
                if (!isShown) {
                    model.zip = null
                }
                return isShown
            },
            validations: { required_if_not_found },
        },
        phone: {
            label: 'Phone',
            type: 'text',
            showIf (model) {
                const isShown = model.not_found
                if (!isShown) {
                    model.phone = null
                }
                return isShown
            },
            onChange (model) {
                Vue.nextTick(() => {
                    model['phone'] = Validation.formatPhoneNumber(model['phone'])
                })
            },
            validations: {
                required_if_not_found,
                phone: Validation.validatePhoneNumber,
            }
        },
        email: {
            label: 'Rental Contact Email',
            type: 'text',
            validations: { required_if_not_found, email },
            showIf (model) {
                const isShown = model.not_found
                if (!isShown) {
                    model.email = null
                }
                return isShown
            },
        },
        status: {
            label: 'Status'
        }
    }
}